import { render, staticRenderFns } from "./EditorTinyMCE.vue?vue&type=template&id=4fbe7814&scoped=true&"
import script from "./EditorTinyMCE.vue?vue&type=script&lang=js&"
export * from "./EditorTinyMCE.vue?vue&type=script&lang=js&"
import style0 from "./EditorTinyMCE.vue?vue&type=style&index=0&id=4fbe7814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe7814",
  null
  
)

export default component.exports